import { useState } from 'react';
import ModalShell from './ModalShell';
import ModalFormFooter from './ModalFormFooter';

const DeleteModal = ({ isOpen, onClose, onDelete, data }) => {
  const [loading, setLoading] = useState(false);

  const safeData = data || {};
  const rawDataName = safeData.dataName || 'item';
  const dataName = rawDataName.charAt(0).toUpperCase() + rawDataName.slice(1);
  const name = safeData.name?.split('_').join(' ');

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete(safeData.id, safeData.tool_id);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={`Delete ${dataName}`}
      maxWidthClass="max-w-md"
      footer={
        <ModalFormFooter
          onCancel={onClose}
          onSubmit={handleDelete}
          isLoading={loading}
          submitLabel="Delete"
          loadingLabel="Deleting.."
          variant="danger"
        />
      }
    >
      <p>
        Are you sure you want to delete{' '}
        {safeData.name ? <b>{name}</b> : <span>this <b>{rawDataName}</b></span>}?
      </p>
    </ModalShell>
  );
};

export default DeleteModal;
